<template>
    <div>
        <div :id="btnId"
            class="btn-wrapper"
            :class="btnStyle">
            <div class="btn-txt"
                v-html="btnLbl"
                @click="clickButton"></div>
        </div>
    </div>
</template>
<script>
// helper
import Locale from '@/helper/locale/locale.js';
export default {
    name: 'PrimaryButton',
    props: {
        btnId: { type: String, required: true },
        btnMsg: { type: String, required: true },
        isBtnDisable: { type: Boolean, default: false },
        isLoading: { type: Boolean, default: false }
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        btnLbl: function () {
            // return this.isLoading ? '' : this.btnMsg;
            return this.btnMsg;
        },
        btnStyle: function () {
            let style = '';
            // style = this.theme == 'mass' ? 'mass' : 'prestige';
            if (this.isBtnDisable || this.isLoading)
                style += ' btn-disable'

            return style
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl()
        };
    },
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('clickButton');
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/button.scss';
.btn-wrapper {
    @include base-btn-wrapper (100%, false);
    background-color: $color-red;

    .btn-txt {
        color: $color-white;
        font-weight: 600;
        font-size: 16px;
    }
}
</style>
